import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Layouts from "../../layouts/layouts";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faInfoCircle,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
export default function VehicleAttendanceHistory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [plateNumber, setPlateNumber] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const formatTime = (dateString) => {
    if (!dateString) {
      return "N/A";
    }
    const formattedTime = moment(dateString).format("HH:mm:ss");
    return formattedTime;
  };

  const fetchHistory = async (from, to, pageNumber = page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/driverHistory/vehicle/${id}?page=${pageNumber}&limit=${perPage}&fromDate=${from || ""}&toDate=${to || ""}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setHistory(response.data.driverHistory || []);
      setTotalRows(response.data.total);

      if (response.data.driverHistory?.length > 0) {
        setPlateNumber(
          response.data.driverHistory[0]?.id_vehicle?.numberplate ||
            "Vehicle History",
        );
      }
    } catch (error) {
      console.error("Error fetching driver history:", error);
      setHistory([]);
    }
  };

  // useEffect(() => {
  //   fetchHistory(fromDate, toDate);
  // }, [id, fromDate, toDate]);
  useEffect(() => {
    fetchHistory(fromDate, toDate, page);
  }, [id, fromDate, toDate, page, perPage]);

  const columns = [
    {
      name: <b>Date</b>,
      selector: (row) =>
        moment(row.attendance_driver?.check_in).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: <b>Driver</b>,
      selector: (row) => row.id_driver?.id_user?.name || "-",
      sortable: true,
    },
    {
      name: <b>Client</b>,
      selector: (row) => row.id_client?.name || "-",
      sortable: true,
    },
    {
      name: <b>Check In</b>,
      selector: (row) =>
        row.attendance_driver?.check_in
          ? moment(row.attendance_driver.check_in).format("HH:mm:ss")
          : "-",
      sortable: true,
    },
    {
      name: <b>Check Out</b>,
      selector: (row) =>
        row.attendance_driver?.check_out
          ? moment(row.attendance_driver.check_out).format("HH:mm:ss")
          : "-",
      sortable: true,
    },
  ];
  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };
  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1">
                {plateNumber ? `${plateNumber}` : "Vehicle History"}
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <label>From Date:</label>
                    <input
                      type="date"
                      value={
                        fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""
                      }
                      onChange={(e) => setFromDate(e.target.value)}
                      className="form-control"
                      style={{ width: "150px" }}
                    />
                  </div>
                  <div>
                    <label>To Date:</label>
                    <input
                      type="date"
                      value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
                      onChange={(e) => setToDate(e.target.value)}
                      className="form-control"
                      style={{ width: "150px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={history}
                  pagination
                  paginationServer
                  fixedHeader
                  highlightOnHover
                  responsive
                  paginationPerPage={perPage}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
